import React, {useCallback, useMemo, useState} from "react"
import WhiteLogoImage from "../../assets/icons/ngs-white-blue.svg"
import {useParams} from "react-router-dom";
import {apiV2, massWarningAPI} from "../../api/axiosConfig";
import { useQuery } from "react-query";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import {ButtonV2} from "../../components/ui/ButtonsV2/ButtonV2";
import clsx from "clsx";

const Layout: React.FC<React.PropsWithChildren> = (props) => {


    return (
        <div className={"flex flex-col items-center justify-start gap-8 text-grey bg-desaturated-grey min-h-screen"}>
            <Header/>
            <div className="w-full p-8 flex flex-col items-center gap-8">
                {props.children}
            </div>
        </div>
    )

}

const Header: React.FC = () => {


    return <div
        className="bg-white bg-gradient-to-r from-[#2D166F_50%] to-[#007584] h-28 w-full px-6 flex justify-center">
        <img
            src={WhiteLogoImage}
            alt="NGS Logo"
            className="h-fill w-auto max-h-30 max-w-[200px] object-contain"
        />
    </div>

}

type OptOutStatus = {
    optOut: boolean
}

async function fetchData(id: string) {
    const res = await apiV2.get<OptOutStatus>(`siren/opt-out/${id}`, {})
    return res.data;
}

function Inner({optOut}: OptOutStatus) {

    const {id} = useParams()

    const [loading, setLoading] = useState(false)
    const [submitted, setSubmitted] = useState(false)
    const [error, setError] = useState<string>()

    const submit = useCallback(() => {
        setLoading(true)

        apiV2.post(`siren/opt-out/${id}`).then(()=>{
            setSubmitted(true)
        }).catch(()=> {
            setError("Error submitting response")
        }).finally(() => {
            setLoading(false)
        })
    }, [id])


    if(submitted){
        return <p className="text-center">Opt-out request submitted.</p>

    }


    if (optOut) {
        return <p className="text-center">You are already opted out of receiving siren messages.</p>
    }


    if (error) {
        return <p className="text-center text-red">{error}</p>
    }



    return (
        <div className={"flex flex-col gap-4"}>
            <p>Please click the button if you want to opt out of receiving future siren messages.</p>
            <ButtonV2 label={"Opt-Out"} onClick={submit} loading={loading}/>
        </div>
    )

}


export function SirenOptOut() {

    const {id} = useParams()

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ["opt-out", id],
        queryFn: () => fetchData(id!),
        enabled: !!id,
    });

    const content = useMemo(() => {
        if (isLoading) { return <p>Loading...</p>}
        if (isError) { return <p>An error occurred</p> }
        if(data) return <Inner {...data}/>


    }, [data, isLoading, isError, error]);




    return (
        <Layout>
            {content}
        </Layout>
    )
}